import { IconCustomMenuDown } from '../../icons/tabler';
import { Components, SvgIcon } from '../../material';

export const MuiSelect: Components['MuiSelect'] = {
  defaultProps: {
    IconComponent: args => (
      <SvgIcon {...args}>
        <IconCustomMenuDown />
      </SvgIcon>
    ),
  },
};
